<div class="container-fluid">
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">{{headerText}}</h1>
    </div>
  </div>
  <div class="row no-gutters" *ngIf="(routedFrom == 'pscHrAccepted' ||
               routedFrom == 'pscHrRejected' ||
               routedFrom == 'pscHrmAccepted' ||
               routedFrom == 'pscHrmRejected' ||
               routedFrom == 'pscAcctReceived')">
    <div class="col-xs-2">
      <b>Show All PSCs?: </b>
      <mat-checkbox id="Show All PSCs" name="Show All PSCs" [(ngModel)]="showAllPscs" (change)="handleShowAllPscs()">
      </mat-checkbox>
    </div>
  </div>
  <div class="row no-gutters" *ngIf="(routedFrom == 'pscDmApproval' && canPmmApprove())">
    <div class="col-xs-2">
      <b>Show all Dept PSCs?: </b>
      <input style="width: 13px" type="checkbox" id="Show all Dept PSCs" name="Show all Dept PSCs"
        [(ngModel)]="showAllDeptPscs" (change)="handleShowAllDeptPscs()" />
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12">

      <!--  PSC Info  -->

      <div id="gridPsc">
        <div class="row">
          <div class="col-xs-12">
            <aims-common-table id="pscs-table" [dataSource]="pscs | async" [header]="pscsHeader" [pageSize]="10"
              [permissions]="tablePermissions" [defaultTableState]="defaultTableState">

              <aims-common-table-dynamic-row id="button">
                <ng-template viewMode let-element>
                  <button *ngIf="((permissions.canRead(permissions.ComponentID.PscHrRoutingQueue) && element.unionAffiliationId != NO_REPRESENTATION) ||
                                permissions.canRead(permissions.ComponentID.PscHrmApprovalQueue) ||
                                permissions.canRead(permissions.ComponentID.PscWsLeadReviewQueue) ||
                                permissions.canRead(permissions.ComponentID.PscDmApprovalQueue) ||
                                permissions.canRead(permissions.ComponentID.PscPmmApprovalQueue) ||
                                permissions.canRead(permissions.ComponentID.PscAcctReceivalQueue) ||
                                permissions.canRead(permissions.ComponentID.PscItReceivalQueue))" type="button"
                    mat-mini-fab color="basic" aria-label="Route to PSC"
                    [routerLink]="'/hr/psc/' + element.pscId +'/' +routedFrom">
                    <mat-icon>
                      <span class="whole-cell"
                        [ngStyle]="pscFunc.colorCodeDate(element.effectiveOn, element.accepted, element.rejected)">
                        launch
                      </span>
                    </mat-icon>
                  </button>
                </ng-template>
              </aims-common-table-dynamic-row>

              <aims-common-table-dynamic-row id="employeeStatusToId">
                <ng-template viewMode let-element>{{ element.employeeStatusToId|
                  getText:'employeeStatusId':'employeeStatus':employeeStatusValues | async}}
                </ng-template>
                <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                  <mat-form-field appearance="fill" class="top20 fullWidth">
                    <mat-label>Filter</mat-label>
                    <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                      <mat-option label=""></mat-option>
                      <mat-option *ngFor="let val of employeeStatusValues | async" [value]="val.employeeStatusId">
                        {{val.employeeStatus}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-template>
              </aims-common-table-dynamic-row>

              <aims-common-table-dynamic-row id="pscTypeId">
                <ng-template viewMode let-element>{{ element.pscTypeId|
                  getText:'pscTypeId':'pscType':pscTypeValues | async}}
                </ng-template>
                <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
                  <mat-form-field appearance="fill" class="top20 fullWidth">
                    <mat-label>Filter</mat-label>
                    <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                      <mat-option label=""></mat-option>
                      <mat-option *ngFor="let val of pscTypeValues | async" [value]="val.pscTypeId">
                        {{val.pscType}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-template>
              </aims-common-table-dynamic-row>

              <aims-common-table-dynamic-row id="wsLeadReviewedOn">
                <ng-template viewMode let-element>
                  <span class="whole-cell"
                    [ngStyle]="pscFunc.colorRequiredStatus('WS', element.wsLeadReviewedOn, element.pscTypeId, element.employeeStatusToId, element.unionAffiliationId, allPscTypes, allEmployeeStatuses )">
                    {{ element.wsLeadReviewedOn | date: 'MM/dd/yy' }}
                  </span>
                </ng-template>
              </aims-common-table-dynamic-row>

              <aims-common-table-dynamic-row id="dmApprovedOn">
                <ng-template viewMode let-element>
                  <span class="whole-cell"
                    [ngStyle]="pscFunc.colorRequiredStatus('DM', element.dmApprovedOn, element.pscTypeId, element.employeeStatusToId, element.unionAffiliationId, allPscTypes, allEmployeeStatuses )">
                    {{ element.dmApprovedOn | date: 'MM/dd/yy' }}
                  </span>
                </ng-template>
              </aims-common-table-dynamic-row>

              <aims-common-table-dynamic-row id="pmmApprovedOn">
                <ng-template viewMode let-element>
                  <span class="whole-cell"
                    [ngStyle]="pscFunc.colorRequiredStatus('PMM', element.pmmApprovedOn, element.pscTypeId, element.employeeStatusToId, element.unionAffiliationId, allPscTypes, allEmployeeStatuses )">
                    {{ element.pmmApprovedOn | date: 'MM/dd/yy' }}
                  </span>
                </ng-template>
              </aims-common-table-dynamic-row>              

              <aims-common-table-dynamic-row id="hrmApprovedOn">
                <ng-template viewMode let-element>
                  <span class="whole-cell"
                    [ngStyle]="pscFunc.colorRequiredStatus('HRM', element.hrmApprovedOn, element.pscTypeId, element.employeeStatusToId, element.unionAffiliationId, allPscTypes, allEmployeeStatuses )">
                    {{ element.hrmApprovedOn | date: 'MM/dd/yy' }}
                  </span>
                </ng-template>
              </aims-common-table-dynamic-row>         

              <aims-common-table-dynamic-row id="acctReceivedOn">
                <ng-template viewMode let-element>
                  <span class="whole-cell"
                    [ngStyle]="pscFunc.colorRequiredStatus('ACCT', element.acctReceivedOn, element.pscTypeId, element.employeeStatusToId, element.unionAffiliationId, allPscTypes, allEmployeeStatuses )">
                    {{ element.acctReceivedOn | date: 'MM/dd/yy' }}
                  </span>
                </ng-template>
              </aims-common-table-dynamic-row>        

              <aims-common-table-dynamic-row id="itReceivedOn">
                <ng-template viewMode let-element>
                  <span class="whole-cell"
                    [ngStyle]="pscFunc.colorRequiredStatus('IT', element.itReceivedOn, element.pscTypeId, element.employeeStatusToId, element.unionAffiliationId, allPscTypes, allEmployeeStatuses )">
                    {{ element.itReceivedOn | date: 'MM/dd/yy' }}
                  </span>
                </ng-template>
              </aims-common-table-dynamic-row>                    

            </aims-common-table>

          </div>
        </div>

      </div>



    </div>
  </div>
</div>